module.exports = __webpack_public_path__ + "static/large-pillar-d392978d7d14ac770b7f44c71899105e.png";